import { useEffect } from 'react'
import { setViewerCanUseSystemAdminMode } from 'shared/utils'

export const useInitializeViewerMode = (
  viewerCanUseSystemAdminMode?: boolean | null
) => {
  useEffect(() => {
    if (viewerCanUseSystemAdminMode == null) return

    setViewerCanUseSystemAdminMode(viewerCanUseSystemAdminMode)
  }, [viewerCanUseSystemAdminMode])
}
